module.exports = __webpack_public_path__ + "img/logo4.c46fecfa.png";